export const categoryPageConfigs = {
  flowers: {
    categoryId: "flowers",
    categoryData: {
      name: "פרחים",
      icon: "🌹",
      description: "פרחים טריים איכותיים מהמגדלים המובחרים בארץ ובעולם",
      benefits: [
        "סחורה טרייה ואיכותית ברמה גבוהה",
        "מבחר עשיר שמתחדש בהתאם לעונה ולזמינות במלאי",
        "מחירים מותאמים לרוכשים בסיטונאות",
        "זמינות נוחה לאיסוף מהיר",
        "שירות מקצועי עם ניסיון בתחום הפרחים",
      ],
    },
  },
  greenery: {
    categoryId: "greenery",
    categoryData: {
      name: "ירוקים",
      icon: "🌿",
      description: "ירוקים משלימים לסידורים עשירים ומלאי נפח",
      benefits: [
        "תוספת נפח ומרקם לכל זר",
        "מבחר ענפים ועלים טריים",
        "התאמה לסגנונות עיצוב מגוונים",
        "סחורה טרייה לפי זמינות עונתית",
        "פתרונות ירוקים גמישים לכל סגנון עיצוב",
      ],
    },
  },
  plants: {
    categoryId: "plants",
    categoryData: {
      name: "צמחים",
      icon: "🪴",
      description: "צמחים בריאים ומטופחים לבית, למשרד ולמתנות",
      benefits: [
        "צמחים איכותיים במגוון גדלים",
        "פתרון ירוק ועמיד לאורך זמן",
        "מתאימים לעיצוב חללים מכל סוג",
        "מחירים נוחים לרכישה מרוכזת",
        "הנחיות בסיסיות לשמירה על הצמח",
      ],
    },
  },
  driedFlowers: {
    categoryId: "driedFlowers",
    categoryData: {
      name: "פרחים יבשים",
      icon: "🌾",
      description: "פרחים יבשים טבעיים ומעוצבים לשימוש ארוך טווח",
      benefits: [
        "מראה ייחודי שנשמר לאורך זמן",
        "תחזוקה מינימלית ללא השקיה",
        "מתאימים לעיצוב ביתי ומסחרי",
        "מבחר גוונים וטקסטורות",
        "שירות מקצועי בהתאמה לסגנון",
      ],
    },
  },
  accessories: {
    categoryId: "accessories",
    categoryData: {
      name: "אביזרים",
      icon: "🎀",
      description: "אביזרים משלימים לעיצוב מקצועי ומדויק",
      benefits: [
        "מבחר רחב של סרטים, חוטים וקישוטים",
        "איכות שמחזיקה לאורך זמן",
        "פתרונות לעיצוב מהיר לאירועים",
        "מחירים נוחים לרכישה בכמות",
        "זמינות גבוהה לאיסוף מהיר",
      ],
    },
  },
  floralTools: {
    categoryId: "floralTools",
    categoryData: {
      name: "כלים",
      icon: "✂️",
      description: "ציוד מקצועי לעבודה עם פרחים, לדיוק ונוחות מקסימליים",
      benefits: [
        "כלים מקצועיים איכותיים",
        "מותגים מובילים מהארץ ומהעולם",
        "עמידות גבוהה לשימוש יומיומי",
        "מחירים משתלמים לקנייה מרוכזת",
        "ליווי מקצועי בבחירת ציוד מתאים",
      ],
    },
  },
};
